import { render, staticRenderFns } from "./modal-registrasi-sap.vue?vue&type=template&id=6780c086&scoped=true&"
import script from "./modal-registrasi-sap.vue?vue&type=script&lang=js&"
export * from "./modal-registrasi-sap.vue?vue&type=script&lang=js&"
import style0 from "./modal-registrasi-sap.vue?vue&type=style&index=0&id=6780c086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6780c086",
  null
  
)

export default component.exports